import styled from 'styled-components';

/* Mixins */
import {
  WebFontBody2,
  WebFontCaption1,
  WebFontCallout1,
  WebFontCallout2,
  WebFontCallout3,
} from 'styles/Mixins';

const TitleMixin = ({ size, bold }: { size?: string; bold?: boolean } = {}) => {
  let font;
  switch (size) {
    case 'small':
      font = bold ? WebFontCallout3 : WebFontCaption1;
      break;
    case 'splash':
      font = bold ? WebFontCallout1 : WebFontBody2;
      break;
    default:
      font = bold ? WebFontCallout2 : WebFontBody2;
      break;
  }

  let padding;
  switch (size) {
    case 'small':
      padding = 'padding: 4px 0;';
      break;
    case 'splash':
      padding = 'padding: 8px 0;';
      break;
    default:
      padding = 'padding: 8px 0;';
  }

  return `${font}${padding}`;
};

export const FormElementTitle = styled.div<{ [props: string]: any }>`
  color: ${({ theme }) => theme.Grey1};
  ${TitleMixin()};
  text-align: left;
`;
